module.exports = __webpack_public_path__ + "img/20230705-110247.fabdf36f.webp";